import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fl-row-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "删除"),
  /*#__PURE__*/_createTextVNode(" 该角色?")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "删除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      class: "fl-clean filterForm actionLog__filterForm",
      model: _ctx.filterParams,
      layout: 'inline'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "操作人" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.filterParams.userName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.userName) = $event)),
              "allow-clear": ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "功能模块" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tree_select, {
              value: _ctx.filterParams.menuId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.menuId) = $event)),
              style: {"width":"170px"},
              "allow-clear": "",
              "show-line": true,
              "tree-data": _ctx.menuTree,
              "search-placeholder": "请选择"
            }, null, 8, ["value", "tree-data"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_range_picker, {
              value: _ctx.filterParams.dateRange,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.dateRange) = $event)),
              format: "YYYY-MM-DD"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              ghost: "",
              onClick: _ctx.onRefreshTable
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_app_table, {
      ref: "tableRef",
      size: "default",
      "row-key": "id",
      columns: _ctx.tableColumns,
      data: _ctx.loadTableData,
      "show-pagination": true,
      "page-refresh": false
    }, {
      action: _withCtx(({ record }) => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: { name: 'role.detail', params: { id: record.roleId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode("详情")
            ]),
            _: 2
          }, 1032, ["to"]),
          _hoisted_2,
          (record.initStatus !== 'INIT')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_link, {
                  to: { name: 'role.edit', params: { id: record.roleId } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("修改")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _hoisted_3,
                _createVNode(_component_router_link, {
                  to: { name: 'role.staff', params: { id: record.roleId } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("管理人员")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _hoisted_4,
                _createVNode(_component_a_popconfirm, {
                  placement: "top",
                  onConfirm: ($event: any) => (_ctx.onDelItem(record))
                }, {
                  title: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ], 64))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'role.owner', params: { id: record.roleId } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看 / 转移账户")
                ]),
                _: 2
              }, 1032, ["to"]))
        ])
      ]),
      _: 1
    }, 8, ["columns", "data"])
  ]))
}